import { registerPlugin } from "@capacitor/core";
const SavePassword = registerPlugin("SavePassword");
export * from "./definitions";
export { SavePassword };
//# sourceMappingURL=index.js.map